import { FC, useEffect, useState } from 'react';
import { StyledBackToTop } from './Styled';
import PageTop from '../../icons/PageTop';

const BackToTop: FC<{ container?: HTMLElement; invert?: boolean }> = ({
  container,
  invert
}) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handler = () =>
      setIsVisible(
        (container ? container.scrollTop : window.scrollY) * (invert ? -1 : 1) >
          500
      );
    (container || window).addEventListener('scroll', handler);
    return () => (container || window).removeEventListener('scroll', handler);
  }, [container, invert]);
  const goTop = () => {
    (container || window).scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return (
    <StyledBackToTop
      isVisible={isVisible}
      onClick={goTop}
      invert={invert}
      position={container ? 'absolute' : 'fixed'}
    >
      <PageTop width="100%" height="100%" />
    </StyledBackToTop>
  );
};

export default BackToTop;
